import { render, staticRenderFns } from "./_InventoriesStatusTab.vue?vue&type=template&id=b4d014f8&"
import script from "./_InventoriesStatusTab.vue?vue&type=script&lang=js&"
export * from "./_InventoriesStatusTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports